
















































































































import Vue from 'vue'
import * as _ from 'lodash'
// import { ExtranetApi } from '@/api/extranet'
import { remoteConfigColumns } from '../data'

import { ExtranetServiceProxy } from '@/service-proxies/app-v2/extranet.service-proxies'
import { ExtranetProtocolServiceProxy } from '@/service-proxies/app-v2/iot-extranet.service-proxies'

import { ExtranetParamSettingServiceProxy } from "@/service-proxies/app-v2/iot-extranet.service-proxies"

const esp = new ExtranetServiceProxy()
const epsp = new ExtranetProtocolServiceProxy()
const paramSettingProxy = new ExtranetParamSettingServiceProxy()



export default Vue.extend({
  name: 'RemoteConfig',
  props: {
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    deviceId: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    editable: { // 是否允许编辑,默认不可编辑
      type: Boolean,
      default: false
    },
    showStatus: { // 是否显示'连接状态'字段,默认显示
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '240px'
    },
    size: {
      type: String,
      default: 'middle' // 表格尺寸: middle,large
    },
    comPortsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      remoteConfigColumns,
      columns: [],
      listOfData: [],
      index: -999,
      protocolList: [],
      appProtocolList: [],
      scrollX: '1120px',
      virtualIpList: [],
      filterVirtualIpList: [],
      ipList: [],
      disabled: false,
      showSelect: false,
      oldVirtualIpList: [],
      defaultGatewayIp: undefined,
      defaultGatewayVirtualIp: undefined,
      extranetSetting: {}
    }
  },
  watch: {
    tableData: {
      handler(tableData) {
        this.listOfData = _.cloneDeep(tableData)
        if (this.listOfData.length>0){
          const first = this.listOfData[0];
          this.defaultGatewayIp= first.networkIp;
          this.defaultGatewayVirtualIp=first.virtualIp;
        }
      },
      deep: true,
      immediate: true
    },
    deviceId: {
      handler() {

      },
      deep: true,
      immediate: true
    },
    showStatus: {
      handler(showStatus) {
        const status = {
          title: this.$t('page_extranet_Connection_state'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        }
        if (showStatus) {
          this.columns = _.cloneDeep(this.remoteConfigColumns)
          // this.columns.push(status)
        } else {
          this.columns = _.cloneDeep(this.remoteConfigColumns)
        }
      },
      immediate: true
    },
    editable: {
      handler(editable) {
        const action = {
          title: this.$t('actions'),
          fixed: 'right',
          width: '120px',
          scopedSlots: { customRender: 'action' }
        }
        if (editable) {
          this.columns.push(action)
        } else {
          this.scrollX = '1000px'
        }
      },
      immediate: true
    },
    size: {
      handler(size) {
        if (size === 'large') {
          this.columns.map(item => {
            item.width = '205px'
          })
          this.scrollX = '1400px'
        }
      },
      immediate: true
    }
  },
  created() {
    this.getSupportProtocols()
    for (let i = 1; i < 256; i++) {
      this.virtualIpList.push(`COM${i}`)
      if (i > 0 && i < 9) {
        this.ipList.push(`COM${i}`)
      }
    }
    // 过滤已有的
    // console.log('comPortsList:',this.comPortsList)
    this.virtualIpList = this.virtualIpList.filter(item => !this.comPortsList.includes(item))
    this.filterVirtualIpList = _.cloneDeep(this.virtualIpList)
  },
  computed:{
    addEnable: function(){
      const listSize = (this.listOfData || []).length;
      console.log('listSize:',listSize);
      console.log('this.extranetSetting.max:',this.extranetSetting.max);
      return listSize < (this.extranetSetting.max || 0);
    },
    editEnable: function(){
      return this.extranetSetting && this.extranetSetting.editEnable;
    },
    deleteEnable: function (){
      return this.extranetSetting && this.extranetSetting.deleteEnable;
    }
  },
  mounted() {
    paramSettingProxy.getCurrentExtranetParamSetting()
      .then(res=>{
        this.extranetSetting={
          max: res.max,
          editEnable: res.editEnable,
          deleteEnable: res.deleteEnable
        }
      })
  },
  methods: {
    // 获取远程诊断支持的协议集
    getSupportProtocols() {
      // esp.getSupportProtocols().then(res => {
      //   this.protocolList = res.protocolList
      //   this.appProtocolList = res.appProtocolList
      // })
       epsp.getExtranetProtocol().then(res => {
          console.log(res);
          
          this.appProtocolList = res.protocolType
        })
    },
    handleChange(value, id, column) {
      const newData = [...this.listOfData]
      const target = newData.filter(item => id === item.id)[0]

      if (target) {
        if (column === 'protocol') {
          this.handleProtocolChange(value, id, target)
        }
        target[column] = value
        this.listOfData = newData
      }
    },
    // 当传输协议为串口时，清空其他输入框
    handleProtocolChange(value, id, item) {
      // if (value.toLowerCase() === 'serial') {
      //   item.virtualIp = ''
      //   item.virtualPort = '' // 禁用
      //   item.ip = ''
      //   item.port = '' // 禁用
      //   this.disabled = true
      //   this.showSelect = true
      // } else {
      //   this.disabled = false
      //   this.showSelect = false
      // }
    },
    // 编辑
    startEdit(id) {
      this.oldVirtualIpList = []
      this.virtualIpList = _.cloneDeep(this.filterVirtualIpList)
      this.listOfData.forEach(item => {
        if (item.id === id) {
          item.edit = true
          // this.showSelect = item.protocol.toLowerCase() === 'serial'
          // this.disabled = item.protocol.toLowerCase() === 'serial'
        } else {
          // 过滤已经使用的外部地址
          // if (item.protocol.toLowerCase() === 'serial') {
          //   this.oldVirtualIpList.push(item.virtualIp)
          // }
        }
      })
      // 过滤已经使用的外部地址
      this.virtualIpList = this.virtualIpList.filter(item => !this.oldVirtualIpList.includes(item))

      this.listOfData = _.cloneDeep(this.listOfData)
    },
    // 删除
    handleDelete(id) {
      console.log('删除：', id)
      // this.listOfData = this.listOfData.filter(item => item.id !== id)
      this.$emit('handleAction', id)
    },
    // 取消编辑
    cancelEdit(id) {
      if (Number(id) < 0) { // 取消新建
        this.listOfData = this.listOfData.filter(item => item.id !== id)
      } else { // 取消编辑
        const newData = [...this.listOfData]
        const target = newData.filter(item => id === item.id)[0]
        if (target) {
          Object.assign(target, this.tableData.filter(item => id === item.id)[0])
          delete target.edit
          this.listOfData = newData
        }
      }
    },
    // 编辑配置项
    saveEdit(data) {
      console.log('saveEdit:', data)
      const valid = this.valid(data)
      if (!valid) {
        return
      }
      const index = this.listOfData.findIndex(item => item.id === data.id)
      Object.assign(this.listOfData[index], data)
      delete this.listOfData[index].edit
      this.listOfData = _.cloneDeep(this.listOfData)
      const passData = _.cloneDeep(this.listOfData[index])
      delete passData.status
      // 保存的时候将外部地址和内部地址的"COM1"中的数字提取出来
      // if (passData.protocol.toLowerCase() === 'serial') {
      //   passData.virtualIp = passData.virtualIp.replace(/[^0-9]/ig, '')
      //   passData.ip = passData.ip.replace(/[^0-9]/ig, '')
      //   passData.virtualPort = 1
      //   passData.port = 1
      // }

      const body = { data: passData }
      if (Number(passData.id) < 0) { // 新增
        delete passData.id
        Object.assign(body, { type: 'add' })
      } else { // 编辑
        Object.assign(body, { type: 'update' })
      }
      console.log('编辑/新增配置项：', body)
      this.$emit('handleAction', body)
    },
    // 新建配置项
    addConfig() {
      if(!this.addEnable){
        this.$message.error('不允许添加');
        return;
      }
      if (this.deviceId) {
        const addItem = {
          'id': this.index,
          'deviceId': this.deviceId,
          'workStationId': this.deviceId,

          'virtualIp': this.defaultGatewayVirtualIp,
          'networkIp': this.defaultGatewayIp,
          'deviceIp': '',
          'mapIp': '',

          'maxPort': 50000,
          'minPort': 1000,
          'protocol': 'TCP',
          'edit': true
        }
        this.listOfData = [...this.listOfData, addItem]

        this.showSelect = false
        this.disabled = false
        // 过滤已经使用的外部地址
        this.oldVirtualIpList = []
        this.virtualIpList = _.cloneDeep(this.filterVirtualIpList)
        this.listOfData.map(item => {
          // if (item.id > -1 && item.protocol.toLowerCase() === 'serial') {
          //   this.oldVirtualIpList.push(item.virtualIp)
          // }
        })
        this.virtualIpList = this.virtualIpList.filter(item => !this.oldVirtualIpList.includes(item))

        this.index++
      }
    },
    // 校验
    valid(data) {
      let flag = true
     const numberReg = /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/
      const reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
      if (!data.deviceIp) {
        this.$message.error('请输入设备真实Ip')
        return false
      }else {
        if(!reg.test(data.deviceIp)) {
          this.$message.error('设备真实Ip格式错误')
          return false
        }
      }
      
      if (!data.mapIp) {
        this.$message.error('请输入设备虚拟Ip')
        return false
      }else {
        if(!reg.test(data.mapIp)) {
          this.$message.error('设备虚拟Ip格式错误')
          return false
        }
      }
      if(!data.maxPort) {
        if(data.maxPort != 0){
          this.$message.error('请输入可用最大端口')
          return false
        }
      }else {
         if(!numberReg.test(data.maxPort)) {
          this.$message.error('端口格式错误')
          return false
        }
      }
      if(!data.minPort) {
        if(data.minPort != 0){
          this.$message.error('请输入可用最小端口')
          return false
        }
      }else {
        if(!numberReg.test(data.minPort)) {
          this.$message.error('端口格式错误')
          return false
        }
      }
      if (!reg.test(data.networkIp)) {
        this.$message.error('networkIp格式错误')
        return false
      }
      if (!data.virtualIp) {
        this.$message.error('请输入网关虚拟Ip')
        return false
      }else {
          if(!reg.test(data.virtualIp)) {
            this.$message.error('网关虚拟Ip格式错误')
            return false
          }
      }
      // 新建(编辑)的数据，虚拟(虚拟)ip/端口或串口不能与已有的数据完全一致
      this.tableData.map(item => {
        if (item.id !== data.id) {
          if (item.virtualIp === data.virtualIp && item.virtualPort === Number(data.virtualPort)) {
            this.$message.error('此虚拟地址和虚拟端口已存在!')
            flag = false
          }
        }
      })
      return flag
    }
  }
})
